import { HttpHeaders } from "@angular/common/http";
import { DynamicField } from "./dynamic-field.model";

export class DynamicFile<T> extends DynamicField<T> {

    maxFileSize?: number;
    file?: File;
    accept?: string;

    constructor(source: Partial<DynamicFile<T>>) {
        super();
        Object.assign(this, source);
    }
}